const popup = {
  namespaced: true,
  state: {
    item: null,
  },
  mutations: {
    setPopup(state, payload) {
      state.item = payload;
    },
    unsetPopup(state) {
      state.item = null;
    },
  },
  actions: {},
  getters: {},
};

export default popup;
